import { render, staticRenderFns } from "./PNRData.vue?vue&type=template&id=9079d2a4&"
import script from "./PNRData.vue?vue&type=script&lang=js&"
export * from "./PNRData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports